import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import LsvpLogo3D from "./lsvp-logo-3d";

gsap.registerPlugin(ScrollTrigger);

export default class Newsletter2024Ai {
  static _instance = null;

  static create() {
    const pageClass = 'page-newsletter-page';
    const body = document.querySelector('body');
    const mainElement = document.querySelector('main[data-template]');
    const templateName = mainElement ? mainElement.getAttribute('data-template') : null;
    if (templateName && ['newsletter-page.blade.php', 'game-changers.blade.php'].includes(templateName)) {
      if (Newsletter2024Ai._instance === null) {
        Newsletter2024Ai._instance = new Newsletter2024Ai();
      }
	  }
  }

  static destroy() {
    if (Newsletter2024Ai._instance) {
      Newsletter2024Ai._instance.beforeDestroy();
      Newsletter2024Ai._instance = null;
    }
  }

  constructor() {
    this.scroller = window.scroller // LocomotiveScroll instance
    // slow down the scroll speed
    // this.scroller.scroll.multiplier = 0.5;
    this.isMobile = this.scroller.scroll.isMobile;
    this.isTablet = this.scroller.scroll.isTablet;

    const mainElement = document.querySelector('main[data-template]');
    const templateName = mainElement ? mainElement.getAttribute('data-template') : null;
    this.isPageGameChangers = templateName === 'game-changers.blade.php';
    this.isPageNewsletter = templateName === 'newsletter-page.blade.php';

    this.scrollAnimations();
    this.initNavigation();
    this.setupScrollTrigger();
    this.setupMenuColorScrollTrigger();
  }

  initNavigation() {
    this.header = document.getElementById('header');
    this.sections = Array.from(document.querySelectorAll('.section-content'));
    this.navLinks = Array.from(document.querySelectorAll('.nav-timeline .nav a'));
    this.colorMenuSections = Array.from(document.querySelectorAll('.color-menu'));

    this.navLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('href').substring(1);
        const targetSection = document.getElementById(targetId);

        if (!targetSection) {
          console.error(`Target section not found: ${targetId}`);
          return;
        }

        // Get the offset for the target section
        let offset;

        if(this.isMobile) {
          offset = targetSection.dataset.scrollOffsetMobile || targetSection.dataset.scrollOffset || '0';
        } else {
          offset = targetSection.dataset.scrollOffset || '0';
        }
        console.log('offset', offset);
        if (offset.endsWith('%')) {
          const percentage = parseFloat(offset) / 100;
          offset = window.innerHeight * percentage;
        }

        // Scroll to the target section with the specified offset
        this.scroller.scrollTo(targetSection, {
          offset: parseInt(offset),
          duration: 1000,
          easing: [0.25, 0.00, 0.35, 1.00]
        });
      });
    });
  }

  setupScrollTrigger() {
    this.sections.forEach((section) => {
      try {
        ScrollTrigger.create({
          trigger: section,
          start: 'top 50%',
          end: 'bottom 50%',
          scroller: '[data-scroll-container]',
          invalidateOnRefresh: true,
          onEnter: () => this.updateActiveLink(section.id, true),
          onEnterBack: () => this.updateActiveLink(section.id, true),
        });
      } catch (error) {
        console.error(`Error creating ScrollTrigger for section ${section.id}:`, error);
      }
    });
  }

  setupMenuColorScrollTrigger() {
    this.colorMenuSections.forEach((section) => {
      ScrollTrigger.create({
        trigger: section,
        start: 'top 90px',
        end: 'bottom 90px',
        scroller: '[data-scroll-container]',
        invalidateOnRefresh: true,
        onEnter: () => this.updateMenuColor(section),
        onEnterBack: () => this.updateMenuColor(section),
      });
    });
  }

  updateActiveLink(sectionId, isActive) {
    const currentLink = document.querySelector(`.nav-timeline .nav a[href="#${sectionId}"]`);

    if (!currentLink) {
      console.error(`Link not found for id: ${sectionId}`);
      return;
    }

    if (isActive) {
      // Remove active class from all links
      this.navLinks.forEach(link => link.parentElement.classList.remove('active'));

      // Add active class to current link
      currentLink.parentElement.classList.add('active');
    }
  }

  updateMenuColor(section) {
    if (this.header) {
      this.header.classList.remove('dark-menu', 'light-menu');
      if (section.classList.contains('dark-menu')) {
        this.header.classList.add('dark-menu');
      } else if (section.classList.contains('light-menu')) {
        this.header.classList.add('light-menu');
      }
    } else {
      console.error('Header element not found');
    }
  }

  resetMenuColor() {
    if (this.header) {
      this.header.classList.remove('dark-menu', 'light-menu');
    } else {
      console.error('Header element not found');
    }
  }

  animationArrow() {

// Initial position
    gsap.set('.animation-arrow', { x: -200, y: 0 });

// Animation during .intro section
    gsap.to('.animation-arrow', {
      x: () => {
        return this.isMobile ? window.innerWidth * 2 : window.innerWidth
      },
      ease: 'none',
      scrollTrigger: {
        trigger: '.nl-hero',
        start: 'top top',
        end: 'bottom top',
        scrub: true,
        scroller: '[data-scroll-container]'
      }
    });
  }

  animationHero() {
    // Title Exploring the impact of AI
    gsap.to('.txt-wrap .h2', {
      scrollTrigger: {
        trigger: '.nl-hero',
        start: 'top top',
        end: '50% top',
        scroller: '[data-scroll-container]',
        scrub: true,
      },
      scale: 0.7,
      transformOrigin: 'left bottom',
      ease: 'power1.out',
    });
  }

  animationExploringMinds() {
    gsap.set('.nl-exploring-minds .heading h2 b', {
      x: '-100vw',
    });

    gsap.set('.nl-exploring-minds .heading h2 span', {
      x: '100vw',
    });

    gsap.set('.nl-exploring-minds .heading .icon-arrow', {
      x: '100vw',
    });

    gsap.timeline({
      scrollTrigger: {
        trigger: '.nl-exploring-minds',
        start: 'top 70%',
        end: 'top 50%',
        scrub: true,
        scroller: '[data-scroll-container]',
      }
    })
    .to('.nl-exploring-minds .heading h2 b', {
      x: 0,
      ease: 'power1.out',
    }, 0)
    .to('.nl-exploring-minds .heading h2 span', {
      x: 0,
      ease: 'power1.out',
    }, 0);

    gsap.to('.nl-exploring-minds .heading h2', {
      scale: 0.7,
      transformOrigin: 'right top',
      scrollTrigger: {
        trigger: '.nl-exploring-minds',
        start: 'top 55%',
        end: 'top 20%',
        scrub: true,
        scroller: '[data-scroll-container]',
        invalidateOnRefresh: true,
      }
    })

    gsap.to('.nl-exploring-minds .heading .icon-arrow', {
      x: 0,
      transformOrigin: 'right top',
      scrollTrigger: {
        trigger: '.nl-exploring-minds',
        start: 'top 55%',
        end: 'top 20%',
        scrub: true,
        scroller: '[data-scroll-container]',
        invalidateOnRefresh: true,
      }
    })

    const newsPosts = document.querySelectorAll('.nl-exploring-minds .nl-post-list .news-post-row');

    newsPosts.forEach((post, index) => {
      gsap.set(post, {
        opacity: 0,
        x: () => {
          return index % 2 === 0 ? 200 : -200;
        }
      });

      gsap.to(post, {
        opacity: 1,
        x: 0,
        scrollTrigger: {
          trigger: post,
          start: 'top 80%',
          end: 'top 45%',
          scrub: true,
          scroller: '[data-scroll-container]',
        }
      })
    })

    // ScrollTrigger.create({
    //   trigger: "#events",
    //   start: "bottom bottom",
    //   end: () => {
    //     return `+=${document.querySelector('#events').offsetHeight}`;
    //   },
    //   pin: '.nl-exploring-minds--inner',
    //   pinSpacing: false,
    //   scroller: '[data-scroll-container]',
    //   pinType: this.isMobile ? 'fixed' : 'transform',
    //   invalidateOnRefresh: true,
    // });

  }

  animationStories() {
    const storiesHeading = document.querySelector('#stories .heading h2');
    const storiesHeadingSpan = storiesHeading.querySelector('span');
    const fullStory = document.getElementById('full-story')

    gsap.set(storiesHeadingSpan, {
      scale: 2.5,
      xPercent: -50,
      yPercent: -50,
      left: '50%',
      transformOrigin: 'center center'
    })

    gsap.to(storiesHeadingSpan, {
      scale: 1,
      yPercent: 0,
      ease: 'power1.out',
      scrollTrigger: {
        trigger: '#stories',
        start: 'top 70%',
        end: 'top 30%',
        scrub: true,
        scroller: '[data-scroll-container]',
        invalidateOnRefresh: true,
      }
    })

    gsap.to(storiesHeadingSpan, {
      xPercent: 0,
      left: () => {
        // align to the right
        const containerWidth = storiesHeading.offsetWidth;
        const spanWidth = storiesHeadingSpan.offsetWidth;
        const delta = containerWidth - spanWidth;
        return `${delta}px`;
      },
      ease: 'power1.out',
      scrollTrigger: {
        trigger: '#stories',
        start: 'top 30.5%',
        end: 'top 0%',
        scrub: true,
        scroller: '[data-scroll-container]',
        invalidateOnRefresh: true,
      }
    })

    gsap.set('#stories .heading p span', {
      opacity: 0,
      x: "-=100"
    })

    let storiesHeadingParagraphStart = 'top 30%';
    if(this.isPageGameChangers) {
      storiesHeadingParagraphStart = 'top 50%';
    }

    let storiesHeadingParagraphEnd = 'top 0%';
    if(this.isPageGameChangers) {
      if(this.isMobile) {
        storiesHeadingParagraphEnd = 'top 30%';
      } else {
        storiesHeadingParagraphEnd = 'top 20%';
      }
    }

    gsap.to('#stories .heading p span', {
      opacity: 1,
      x: 0,
      ease: 'power1.out',
      stagger: 0.2,
      scrollTrigger: {
        trigger: '#stories',
        start: storiesHeadingParagraphStart,
        end: storiesHeadingParagraphEnd,
        scrub: true,
        scroller: '[data-scroll-container]',
        invalidateOnRefresh: true,
      }
    })

    if(fullStory) {
      const fullStoryFigure = fullStory.querySelector('.img')
      if(fullStoryFigure) {
        const fullStoryFigureBounds = fullStoryFigure.getBoundingClientRect()
        const maskProportion = {
          width: 0.9,
          height: 0.95
        }

        const maskWidth = fullStoryFigureBounds.width * maskProportion.width
        const maskHeight = fullStoryFigureBounds.width * .5625 * maskProportion.height

        const maskBounds = {
          top: 0,
          left: maskWidth / 2,
          right: maskWidth / 2,
          bottom: maskHeight
        }

        gsap.set(fullStoryFigure, {
          clipPath: `inset(${maskBounds.top}px ${maskBounds.right}px ${maskBounds.bottom}px ${maskBounds.left + 1}px)`,
          y: "-=100",
          opacity: 0
        })

        const fullStoryTimeline = gsap.timeline({
          scrollTrigger: {
            trigger: fullStory,
            start: () => {
              return this.isMobile ? "top 87%" : "top 70%"
            },
            end: "+=30%",
            scrub: true,
            scroller: '[data-scroll-container]',
          },
        })
          .to(fullStoryFigure, {
            opacity: 1,
            ease: "power1.inOut",
          }, 0)
          .to(fullStoryFigure, {
          y: 0,
          clipPath: "inset(0px 0px 0px 0px)",
          ease: "none",
        }, 0);

      }
    }

    const slider = document.querySelector('.nl-stories-slider')

    const footer = document.querySelector('.nl-stories-footer')
    if(footer) {
      const footerTitle = footer.querySelector('h2')
      if(slider) {
        gsap.to(slider, {
          scale: .8,
          transformOrigin: 'center center',
          ease: 'none',
          scrollTrigger: {
            trigger: '.nl-stories',
            start: 'bottom 100%',
            end: 'bottom 80%',
            scrub: true,
            scroller: '[data-scroll-container]',
          }
        })
      }

      if(footerTitle) {
        gsap.set(footerTitle, {
          y: "-=100%",
        })
        gsap.to(footerTitle, {
          scale: 1,
          opacity: 1,
          transformOrigin: 'center center',
          y: "40%",
          ease: 'none',
          scrollTrigger: {
            trigger: '.nl-stories',
            start: 'bottom 120%',
            end: 'bottom 80%',
            scrub: true,
            scroller: '[data-scroll-container]',
            invalidateOnRefresh: true,
          }
        })

        gsap.to(footerTitle, {
          scale: .5,
          ease: 'none',
          transformOrigin: 'center center',
          scrollTrigger: {
            trigger: '.nl-stories',
            start: 'bottom 80%',
            end: () => {
              return `+=${window.innerHeight * .66}`;
            },
            scrub: true,
            scroller: '[data-scroll-container]',
            invalidateOnRefresh: true,
          }
        })
      }
    }
  }

  animationOnAi() {
    const title = document.querySelector('#on_ai .heading .category-title');
    const headline = document.querySelector('#on_ai .heading h2');
    const ellipse = document.querySelector('#on_ai .heading .ellipse');
    const story = document.querySelector('#on-ai--story');

    gsap.set(title, {
      scale: 7,
      transformOrigin: 'center center',
    })

    gsap.set(headline, {
      opacity: 0,
      scale: 3,
      transformOrigin: 'center center',
    })

    gsap.set(ellipse, {
      opacity: 0,
      transformOrigin: 'center center',
    })

    ScrollTrigger.create({
      trigger: "#on-ai--hero",
      start: "top top",
      end: () => {
        return `+=${window.innerHeight * 1.5}`;
      },
      pin: '#on-ai--hero-inner',
      pinSpacing: true,
      scroller: '[data-scroll-container]',
      pinType: this.isMobile ? 'fixed' : 'transform',
      invalidateOnRefresh: true,
    });

    const dummy = {
      progress: 0
    }

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: '#on-ai--hero',
        start: 'top 40%',
        end: 'bottom top',
        scrub: true,
        scroller: '[data-scroll-container]',
        invalidateOnRefresh: true,
      }
    })

    timeline.fromTo(title, {
        scale: 7,
        y: () => {
          return `${window.innerHeight / 2}`;
        },
      },
      {
        duration: .2,
        scale: 5,
        y: () => {
          return `${window.innerHeight / 4}`;
        },
        ease: 'none',
    }, 0)

    timeline.to(title,
      {
        duration: .2,
        scale: 2.5,
        // y: () => {
        //   return `-${window.innerHeight / 4}`;
        // },
        ease: 'none',
      }, 0.2)

    timeline.fromTo(headline, {
        opacity: 0,
        scale: 3,
        y: () => {
          return `${window.innerHeight / 2}`;
        }
      },
      {
        opacity: 1,
        duration: .2,
        scale: 2,
        y: () => {
          return `${window.innerHeight / 3.5}`;
        },
        ease: 'none',
      }, 0.2)

    timeline.to(title,
      {
        duration: .2,
        scale: 1,
        y: 0,
        ease: 'none',
      }, 0.4)

    timeline.to(headline,{
        duration: .2,
        scale: 1,
        y: 0,
        ease: 'none',
      }, 0.4)

    timeline.fromTo(ellipse, {
        opacity: 0,
        y: () => {
          return `${window.innerHeight / 3.5}`;
        },
      },
      {
        duration: .2,
        opacity: 1,
        y: 0,
        ease: 'none',
    }, 0.4)

    if(story) {
      timeline.fromTo(story, {
        opacity: 0,
        y: "+=100",
        scale: 1.4,
      },{
        opacity: 1,
        y: 0,
        scale: 1,
        duration: .2,
        transformOrigin: 'center top',
        ease: 'none',
      }, 0.6)
    }

    timeline.to(dummy, {
      progress: 1,
      duration: .2,
      ease: 'none',
    }, 0.8)


    if(story && ! this.isMobile) {
      gsap.to(story, {
        scale: 0.6,
        ease: 'none',
        scrollTrigger: {
          trigger: story,
          start: 'top 50%',
          end: 'bottom 20%',
          scrub: true,
          scroller: '[data-scroll-container]',
          invalidateOnRefresh: true,
        }
      })
    }
  }

  animationPodcasts() {
    const podcastsContainer = document.querySelector('.nl-podcast')
    const podcastsHeading = podcastsContainer.querySelector('.heading h2')
    const dummy = {
      progress: 0
    }

    if(podcastsContainer && podcastsHeading) {
      // gsap.set(podcastsHeading, {
      //   scale: 3,
      //   y: () => {
      //     return `-${window.innerHeight / 2}`;
      //   },
      //   transformOrigin: 'center center',
      // })

      gsap.fromTo(podcastsHeading, {
        scale: 3,
        y: () => {
          return `-${window.innerHeight / 2}`;
        },
      },{
        scale: 1,
        y: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: podcastsContainer,
          start: 'top bottom',
          end: "top 40%",
          scrub: true,
          scroller: '[data-scroll-container]',
          invalidateOnRefresh: true,
        }
      })

      gsap.timeline({
        scrollTrigger: {
          trigger: podcastsContainer,
          start: 'top top',
          end: "bottom bottom",
          pin: podcastsHeading,
          pinSpacing: false,
          pinType: this.isMobile ? 'fixed' : 'transform',
          scrub: true,
          scroller: '[data-scroll-container]',
          invalidateOnRefresh: true,
        }
      })
        .fromTo(podcastsHeading, {
        scale: 1,
        y: 0,
      },{
        scale: 1.8,
        y: () => {
          return `${window.innerHeight / 2 - podcastsHeading.offsetHeight}`;
        },
          opacity: 0,
        ease: 'none',
      })
        .to(dummy, {
          progress: 1,
          ease: 'none',
        })
    }

    ScrollTrigger.create({
      trigger: ".nl-podcast",
      start: "bottom bottom",
      end: () => {
        return `+=${window.innerHeight}`;
      },
      pin: '.nl-podcast--inner',
      pinSpacing: false,
      scroller: '[data-scroll-container]',
      pinType: this.isMobile ? 'fixed' : 'transform',
      invalidateOnRefresh: true,
    });
  }

  animationAdvisory() {
    const advisoryContainer = document.querySelector('.nl-unlocking-impact')
    const advisoryHeading = advisoryContainer.querySelector('.heading')
    const images = advisoryContainer.querySelectorAll('.advisory-council-hero .images .img')

    if(advisoryContainer && advisoryHeading) {
      gsap.fromTo(advisoryHeading, {
        scale: 3,
        opacity: 0,
      }, {
        scale: 1,
        opacity: 1,
        transformOrigin: 'right top',
        ease: 'none',
        scrollTrigger: {
          trigger: advisoryContainer,
          start: 'top 80%',
          end: () => {
            return this.isMobile ? "top 40%" : "top 20%"
          },
          scrub: true,
          scroller: '[data-scroll-container]',
          invalidateOnRefresh: true,
        }
      })
    }

    if(advisoryContainer && images.length) {
      gsap.fromTo(images, {
        scale: 1.5,
        opacity: 0,
        x: "50vw",
      },{
        scale: 1,
        x: 0,
        opacity: 1,
        ease: 'none',
        stagger: 0.2,
        scrollTrigger: {
          trigger: advisoryContainer,
          start: 'top 75%',
          end: "top 0%",
          scrub: true,
          scroller: '[data-scroll-container]',
          invalidateOnRefresh: true,
        }
      })
    }
  }

  animationBackgroundsHighlights() {
    /*const backgroundHighlights = gsap.timeline({
      scrollTrigger: {
        trigger: '#highlights',
        endTrigger:'#events',
        start: 'top top',
        end: 'bottom top',
        pin: '#highlights-bg',
        pinSpacing: false,
        scroller: '[data-scroll-container]',
        pinType: this.isMobile ? 'fixed' : 'transform',
        invalidateOnRefresh: true,
        scrub: true,
      }
    })

    backgroundHighlights.to('#highlights-bg--inner', {
      rotate: 270,
      x: () => {
        return `-=${window.innerWidth / 4}`;
      },
      y: () => {
        return `+=${window.innerHeight / 6}`;
      },
      ease: 'none',
    }, "-=0.1")
      .addLabel('start')

    backgroundHighlights.to('#highlights-bg--inner', {
      rotate: 180,
      x: () => {
        return `-=${window.innerWidth / 3}`;
      },
      y: () => {
        return `-=${window.innerHeight / 6}`;
      },
      ease: 'none',
    })
      .addLabel('checkpoint0')

    backgroundHighlights.to('#highlights-bg--inner', {
      rotate: 90,
      x: () => {
        return `-=${window.innerWidth / 6}`;
      },
      y: () => {
        return `+=${window.innerHeight / 6}`;
      },
      ease: 'none',
    })
      .addLabel('checkpoint1')

    backgroundHighlights.to('#highlights-bg--noise', {
      opacity: 1,
      ease: 'none',
    }, "start")

    backgroundHighlights.to('#highlights-bg--inner', {
      rotate: 45,
      x: () => {
        return `+=${window.innerWidth / 2}`;
      },
      ease: 'none',
    }, "checkpoint1")

    backgroundHighlights.to('#highlights-bg--inner', {
      rotate: 0,
      x: () => {
        return `+=${window.innerWidth / 2}`;
      },
      ease: 'none',
    })*/
  }

  animationBackgroundsOnAi() {
    ScrollTrigger.create({
      trigger: '#on_ai',
      start: 'top top',
      end: 'bottom top',
      pin: '#on-ai-bg',
      pinType: this.isMobile ? 'fixed' : 'transform',
      pinSpacing: false,
      scroller: '[data-scroll-container]',
      invalidateOnRefresh: true,
      scrub: true,
    })

    gsap.set('#on-ai-bg--inner', {
      rotate: 30,
      y: () => {
        return `+=${window.innerHeight / 5}`;
      },
    })

    const backgroundAI = gsap.timeline({
      scrollTrigger: {
        trigger: '#on_ai',
        start: 'top 80%',
        end: 'bottom top',
        scroller: '[data-scroll-container]',
        invalidateOnRefresh: true,
        scrub: true,
      }
    })

    backgroundAI.to('#on-ai-bg--inner', {
      rotate: 60,
      x: () => {
        return `-=${window.innerWidth / 3}`;
      },
      y: () => {
        return `+=${window.innerHeight / 5}`;
      },
      ease: 'none',
    })

    backgroundAI.to('#on-ai-bg--inner', {
      rotate: 90,
      ease: 'none',
    })

    backgroundAI.to('#on-ai-bg--inner', {
      rotate: 120,
      y: 0,
      x: 0,
      ease: 'none',
    })
  }
  animationBackgroundsStories() {
    ScrollTrigger.create({
      trigger: '#stories',
      start: 'top top',
      end: 'bottom top',
      pin: '#stories-bg',
      pinType: this.isMobile ? 'fixed' : 'transform',
      pinSpacing: false,
      scroller: '[data-scroll-container]',
      invalidateOnRefresh: true,
      scrub: true,
    })

    const backgroundStories = gsap.timeline({
      scrollTrigger: {
        trigger: '#stories',
        start: 'top 80%',
        end: 'bottom top',
        scroller: '[data-scroll-container]',
        invalidateOnRefresh: true,
        scrub: true,
      }
    })

    gsap.set('#stories-bg--inner', {
      rotate: 90,
    })

    backgroundStories.to('#stories-bg--inner', {
      rotate: -10,
      y: () => {
        return `+=${window.innerHeight / 5}`;
      },
      ease: 'none',
    })

    backgroundStories.to('#stories-bg--inner', {
      rotate: 30,
      x: () => {
        return `-=${window.innerWidth / 3}`;
      },
      ease: 'none',
    })

    backgroundStories.to('#stories-bg--inner', {
      rotate: 60,
      y: () => {
        return `+=${window.innerHeight / 3}`;
      },
      ease: 'none',
    })

    backgroundStories.to('#stories-bg--inner', {
      rotate: 90,
      ease: 'none',
    })

    backgroundStories.to('#stories-bg--inner', {
      rotate: 120,
      y: 0,
      x: 0,
      ease: 'none',
    })
  }

  animationBackgroundsEvents() {
    const backgroundEvents = gsap.timeline({
      scrollTrigger: {
        trigger: '#events',
        start: 'top top',
        end: 'bottom bottom',
        pin: '#events-bg',
        pinSpacing: false,
        scroller: '[data-scroll-container]',
        pinType: this.isMobile ? 'fixed' : 'transform',
        invalidateOnRefresh: true,
        scrub: true,
      }
    })

    backgroundEvents.to('#events-bg--inner', {
      rotate: 270,
      x: () => {
        return `-=${window.innerWidth / 4}`;
      },
      y: () => {
        return `+=${window.innerHeight / 6}`;
      },
      ease: 'none',
    }, "-=0.1")
      .addLabel('start')

    backgroundEvents.to('#events-bg--inner', {
      rotate: 180,
      x: () => {
        return `-=${window.innerWidth / 3}`;
      },
      y: () => {
        return `-=${window.innerHeight / 6}`;
      },
      ease: 'none',
    })
      .addLabel('checkpoint0')

    backgroundEvents.to('#events-bg--inner', {
      rotate: 90,
      x: () => {
        return `-=${window.innerWidth / 6}`;
      },
      y: () => {
        return `+=${window.innerHeight / 6}`;
      },
      ease: 'none',
    })
      .addLabel('checkpoint1')

    backgroundEvents.to('#events-bg--noise', {
      opacity: 1,
      ease: 'none',
    }, "start")

    backgroundEvents.to('#events-bg--inner', {
      rotate: 45,
      x: () => {
        return `+=${window.innerWidth / 2}`;
      },
      ease: 'none',
    }, "checkpoint1")

    backgroundEvents.to('#events-bg--inner', {
      rotate: 0,
      x: () => {
        return `+=${window.innerWidth / 2}`;
      },
      y: () => {
        return `-${window.innerHeight / 10}`;
      },
      ease: 'none',
    })
  }

  animationBackgroundsPodcasts() {
    ScrollTrigger.create({
      trigger: '.nl-podcast',
      start: 'top top',
      end: 'bottom bottom',
      pin: '#podcast-bg',
      pinType: this.isMobile ? 'fixed' : 'transform',
      pinSpacing: false,
      scroller: '[data-scroll-container]',
      invalidateOnRefresh: true,
      scrub: true,
    })

    const backgroundPodcasts = gsap.timeline({
      scrollTrigger: {
        trigger: '.nl-podcast',
        start: 'top 80%',
        end: 'bottom bottom',
        scroller: '[data-scroll-container]',
        invalidateOnRefresh: true,
        scrub: true,
      }
    })

      .to('#podcast-bg--inner', {
        rotate: 20,
        ease: 'none',
      })

      .to('#podcast-bg--inner', {
        rotate: 40,
        x: () => {
          return `-=${window.innerWidth / 4}`;
        },
        ease: 'none',
      })

      .to('#podcast-bg--inner', {
        rotate: 60,
        y: () => {
          return `+=${window.innerHeight / 4}`;
        },
        x: () => {
          return `+=${window.innerWidth / 4}`;
        },
        ease: 'none',
      })

      .to('#podcast-bg--inner', {
        rotate: 80,
        opacity: 0,
        y: () => {
          return `-=${window.innerHeight / 4}`;
        },
        x: () => {
          return `+=${window.innerWidth / 4}`;
        },
        ease: 'none',
      })
  }
  animationBackgrounds() {
    this.animationBackgroundsOnAi();
    this.animationBackgroundsStories();
    this.animationBackgroundsPodcasts();
    this.animationBackgroundsEvents();

    // gsap.set('#advisory > .bg-g', {
    //   opacity: 0,
    // })
    //
    // gsap.fromTo('#advisory > .bg-g', {
    //   opacity: 0,
    // }, {
    //   opacity: 1,
    //   ease: 'none',
    //   scrollTrigger: {
    //     trigger: '#advisory',
    //     start: 'top 80%',
    //     end: 'top 20%',
    //     scrub: true,
    //     scroller: '[data-scroll-container]',
    //     invalidateOnRefresh: true,
    //   }
    // })

  }

  animationLogo() {
    this.logoContainerEl = document.getElementById('lsvp-logo-3d');

    if(this.logoContainerEl) {
      this.logo3d = new LsvpLogo3D(this.logoContainerEl);
    }
  }

  scrollAnimations() {
    this.animationLogo()
    this.animationHero();
    this.animationArrow();
    // this.animationHighlights();
    this.animationOnAi();
    this.animationPodcasts();
    this.animationStories();
    this.animationExploringMinds();
    // this.animationAdvisory();
    this.animationBackgrounds();

    ScrollTrigger.refresh();
  }

  beforeDestroy() {
    if(this.logo3d) {
      this.logo3d.destroy()
    }

    ScrollTrigger.getAll().forEach((t) => t.kill());
  }
}
